import React from "react";
import { ArrowRight, Sparkles, PhoneCall } from "lucide-react";
import { brand, stats, heroImages } from "../mock";

export default function Hero({ onEnroll }) {
  return (
    <section id="home" className="cya-hero-bg relative pt-28 md:pt-32 pb-20 md:pb-28 overflow-hidden">
      {/* colorful blobs */}
      <div className="blob blob-yellow w-72 h-72 -top-16 -left-16" />
      <div className="blob blob-pink w-80 h-80 top-40 -right-20" />
      <div className="blob blob-purple w-64 h-64 bottom-0 left-1/3" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-10 items-center relative z-10">
        <div className="rise-in">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#F59E0B]/40 text-[#B45309] text-xs font-bold tracking-wider uppercase shadow-sm">
            <Sparkles size={14} /> Admissions Open – New Batch
          </div>
          <h1 className="section-title mt-5 text-5xl sm:text-6xl md:text-7xl leading-[0.95] font-black brand-navy">
            LEARN TODAY.
            <br />
            <span className="gold-gradient">LEAD TOMORROW.</span>
            <br />
            <span className="youth-gradient-text">SHAPE YOUR FUTURE.</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-[#0A1740]/75 max-w-xl leading-relaxed">
            {brand.name}, {brand.location} – a modern skill hub where music,
            language, tech and career come together. Practical training. Expert
            mentors. Real outcomes.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button onClick={onEnroll} className="btn-primary px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base">
              Book a Free Demo <ArrowRight size={18} />
            </button>
            <a href={brand.phoneDial} className="btn-ghost px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base">
              <PhoneCall size={18} /> {brand.phone}
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-2xl border border-[#0A1740]/10 bg-white/80 backdrop-blur px-4 py-3 shadow-sm">
                <div className="text-2xl md:text-3xl font-extrabold gold-gradient">{s.value}</div>
                <div className="text-[11px] uppercase tracking-wider text-[#0A1740]/60 mt-1 font-semibold">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative rise-in">
          <div className="relative rounded-3xl overflow-hidden border-4 border-white aspect-[4/5] max-w-md mx-auto shadow-2xl">
            <img
              src={heroImages.primary}
              alt="Young student playing guitar at CYA Youth Academy"
              className="absolute inset-0 w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1740]/90 via-[#0A1740]/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6">
              <div className="text-white/85 text-xs uppercase tracking-[0.35em] mb-2 font-bold">Join Today</div>
              <div className="text-3xl text-amber-300" style={{ fontFamily: "Caveat, cursive" }}>
                Invest in Yourself!
              </div>
            </div>
          </div>

          {/* Floating cards */}
          <div className="hidden md:block absolute -left-6 top-6 floaty2 bg-[#F59E0B] text-[#0A1740] rounded-2xl px-4 py-3 shadow-xl">
            <div className="text-[10px] uppercase tracking-widest font-black">Certified</div>
            <div className="text-sm font-extrabold">Expert Trainers</div>
          </div>
          <div className="hidden md:block absolute -right-4 bottom-16 rotate-[5deg] floaty bg-white text-[#0A1740] rounded-2xl px-4 py-3 shadow-xl">
            <div className="text-[10px] uppercase tracking-widest font-black text-[#EC4899]">4.9★ Rating</div>
            <div className="text-sm font-extrabold">1500+ Learners</div>
          </div>
          <div className="hidden md:block absolute -bottom-4 left-8 rotate-[-4deg] bg-[#22D3EE] text-[#0A1740] rounded-2xl px-4 py-3 shadow-xl floaty">
            <div className="text-[10px] uppercase tracking-widest font-black">7 Courses</div>
            <div className="text-sm font-extrabold">Music • Language • Tech</div>
          </div>
        </div>
      </div>

      {/* Tagline chips */}
      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-14 relative z-10">
        <div className="chip-divider text-[#B45309] text-xs md:text-sm font-black tracking-[0.35em] uppercase justify-center flex">
          {brand.chip.map((c, i) => (
            <React.Fragment key={c}>
              <span>{c}</span>
              {i < brand.chip.length - 1 && <span className="dot" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
